import * as React from 'react';
import classnames from 'classnames';
import { ScrollIntoView, Button } from '@grandvisionhq/common';
import { PasswordWithStrengthIndicator } from '@grandvisionhq/forms';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const PasswordForm = ({ buttonCaption , 'data-t': dataT , className , passwordLabel , children , onSubmit , isLoading ,  })=>{
    const { getLabel  } = useIntl();
    const [state, setState] = React.useState({
        password: {
            value: '',
            isValid: undefined
        }
    });
    const [hasError, setHasError] = React.useState(false);
    const handleSubmit = React.useCallback((event)=>{
        event.preventDefault();
        if (state.password.isValid) {
            setHasError(false);
            onSubmit(state.password.value);
        } else {
            setHasError(true);
        }
    }, [
        onSubmit,
        state
    ]);
    const setPassword = (password)=>{
        const { value , isValid  } = password;
        setState({
            password: {
                value,
                isValid
            }
        });
    };
    return /*#__PURE__*/ React.createElement("form", {
        className: classnames('password-form', className),
        "data-t": dataT,
        noValidate: true,
        onSubmit: handleSubmit
    }, hasError && /*#__PURE__*/ React.createElement(ScrollIntoView, null, /*#__PURE__*/ React.createElement(Alert, {
        variant: "error",
        className: "alert-m-default"
    }, getLabel('account.passwordStrength.notStrongEnough'))), /*#__PURE__*/ React.createElement(PasswordWithStrengthIndicator, {
        label: passwordLabel,
        value: state.password.value,
        onChange: setPassword
    }), children, /*#__PURE__*/ React.createElement(Button, {
        caption: buttonCaption,
        "data-t": "submit",
        type: "submit",
        className: "password-form__button",
        isLoading: isLoading
    }));
};

export { PasswordForm as default };
//# sourceMappingURL=PasswordForm.js.map
